import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Heading from "../../../../Common/Components/Heading";

import Add from '@mui/icons-material/Add';
import DeleteOutline from '@mui/icons-material/DeleteOutline';

import axios from "axios";
import url from "../../../../Common/URL";

import { IconButton } from "@mui/material";
import Button from '@mui/material/Button';
import MaterialReactTable from 'material-react-table';
import { useConfirm } from 'material-ui-confirm';
import { useSelector } from "react-redux";
import { Delete } from "@mui/icons-material";

const QuestionTable = () => {

  const confirm = useConfirm();

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const [lev, setLev] = useState([]);

  const [search, setSearch] = useState({
    level: "", type: "", page: ""
  });

  const Columns = useMemo(
    () => [

      { header: 'Level', accessorKey: 'level_name' },
      { header: 'Type', accessorKey: 'que_type' },
      {
        header: 'Question', id: 'ques_num1', accessorFn: rowData => {
          return ` ${rowData.ques_num1} ${rowData.ques_num2} ${rowData.ques_num3} ${rowData.ques_num4} ${rowData.ques_num5} ${rowData.ques_num6} ${rowData.ques_num7} ${rowData.ques_num8} ${rowData.ques_num9} ${rowData.ques_num10} ${rowData.ques_num11} ${rowData.ques_num12} ${rowData.ques_num13} ${rowData.ques_num14} ${rowData.ques_num15} ${rowData.ques_num16}`;
        }
      },
      { header: 'Answer', accessorKey: 'answer' },
    ],
    [],
  );

  // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%

  const GenerateLevelOption = () => {
    var option = [];

    for (let i = 1; i <= 45; i++) {
      option.push(<option key={i} value={`P${i}`}>{`Page ${i}`}</option>);
    }


    return option;
  };


  // ------------------------Fetching Student table's data-------------------------------------
  useEffect(() => {

    loadLevel();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  //  ------------------------------------------------
  const loadQuestions = async () => {
    setLoading(true);
    const obj = {
      uname: sessionStorage.getItem("username"), level_name: search.level, que_type: search.type,
      page: search.type === "Assignment" ? search.page : ""
    };

    await axios.post(url + "questions_level_type", obj)
      .then((response) => {
        // console.log(response)
        if (response.data.success) {
          let a = response.data.data;
          // console.log(a);
          !a.length ? setData([]) : setData(a);
          setLoading(false);
        } else {
          setData([]);
          setLoading(false);
        }
      })
      .catch((err) => console.log(err));
  };

  // -----------This function will Fetch all the Existing Levels--------------------
  const loadLevel = () => {
    const obj = {
      uname: sessionStorage.getItem("username"),
    };

    axios.post(url + "fetch_levels", obj)
      .then((response) => {
        let a = response.data.data;
        //   console.log(a);
        setLev(a);
      })
      .catch((err) => console.log(err));
  };
  // ------------------------Deleting Student table's data-------------------------------------

  const onDelete = (id, resolve) => {
    const delObj = {
      id: id,
      uname: sessionStorage.getItem("username"),
      tokenId: 123,
    };
    axios.post(url + "delete_question", delObj)
      .then((res) => {
        // console.log(res);
        resolve();
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <div className={useSelector(state => state.sidebar.value) ? 'widthWhenSidebarOpen' : 'widthWhenSidebarClose'}>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb Breadcrumb align-items-center">
            <li className="breadcrumb-item"><Link to="/bulletin">Home</Link></li>
            <li className="breadcrumb-item">Setup</li>
            <li className="breadcrumb-item active" aria-current="page">Question List</li>
          </ol>
        </nav>

        <Heading name="Question List" />

        <div className="row col-12" >

          <div className=" col-md-3 ">
            <select required name="level_name" value={search.level}
              onChange={(e) => setSearch({ ...search, level: e.target.value })} className="form-select">
              <option value="">Choose Level</option>
              {lev.map((data, i) => (<option key={i} value={data.level_name}>{data.level_name}</option>))}
            </select>
          </div>

          <div className="col-md-3 ">
            <select required name="level_name" value={search.type}
              onChange={(e) => setSearch({ ...search, type: e.target.value })} className="form-select">
              <option value="">Choose Question Type</option> <option value="Test">Test</option>
              <option value="Exam">Exam</option> <option value="Assignment">Assignment</option>
            </select>
          </div>

          {search.type === "Assignment" &&
            <div className="col-md-3 ">
              <select required name="level_name" value={search.page}
                onChange={(e) => setSearch({ ...search, page: e.target.value })} className="form-select">
                <option value="">Choose Page</option>
                {GenerateLevelOption()}
              </select>
            </div>}
          <Button className="col-auto ms-auto" variant="contained" disabled={(search.level === "" || search.type === "") ? true : (search.type === "Assignment" && search.page === "" ? true : false)} onClick={loadQuestions}>Search</Button>
        </div>
        <hr className="px-3" />



        <div className="container-fluid">
          <div className="row my-4">
            <div className="col-12 mx-auto d-flex justify-content-end">
              <Button variant="contained" onClick={() => navigate("/add-question")} >Add Question<Add /></Button>
            </div>
          </div>

          <div className="row">
            <div className="col-12 mx-auto mb-5">

              <MaterialReactTable
                state={{ isLoading: loading }}

                columns={Columns}
                data={data}
                enableRowNumbers
                enableRowSelection
                initialState={{ density: 'compact' }}
                enableDensityToggle={false}

                getRowId={(originalRow) => originalRow.ques_id}
                muiTableBodyRowProps={({ row }) => ({
                  onClick: (event) => navigate("/view-question/" + row.id),
                  sx: { cursor: 'pointer' },
                })}

                renderTopToolbarCustomActions={({ table }) => (
                  <Button variant="contained" color="error" startIcon={<Delete />}
                    disabled={table.getSelectedRowModel().rows.length ? false : true}
                    onClick={() => {
                      confirm({ title: "Delete Confirmation", description: 'This will delete selected data permanently.' })
                        .then(() => {
                          let selectedRows = table.getSelectedRowModel().rows;
                          // console.log(selectedRows);
                          const delPromise = selectedRows.map((row) => {
                            return new Promise((resolve, reject) => {
                              onDelete(row.id, resolve);
                            });
                          });
                          Promise.all(delPromise).then(() => {
                            loadQuestions();
                            table.resetRowSelection();
                            toast.info(selectedRows.length + " Row(s) Deleted!");
                          });
                        });
                    }}
                  >Delete
                  </Button>
                )}
              />
            </div>
          </div>

        </div>
      </div>

    </>
  );

};
export default QuestionTable




